import { useKeyPress } from '../hooks/useKeyPress';

export const KeyPressHookWrapper = ({ actions }) => {
    useKeyPress(actions);
    return null;
};
